import { Offer } from '../Types/offerTypes';

const toOptionalPositiveInt = (value: unknown): number | null => {
  const normalized = Number(value);
  if (!Number.isInteger(normalized) || normalized <= 0) {
    return null;
  }

  return normalized;
};

export const normalizeOfferForSubmit = (data: Offer): Offer => {
  return {
    ...data,
    hotelId: toOptionalPositiveInt(data.hotelId),
    regionId: toOptionalPositiveInt(data.regionId),
    countryId: toOptionalPositiveInt(data.countryId),
    companyId: toOptionalPositiveInt(data.companyId),
  };
};

